import React, { useState } from "react";
import { EventBus } from "./eventBus";
import { formatDate, truncateText } from "host/utils";

const MOCK_INSPECTION_DATA = {
  vehicleInfo: {
    plateNumber: "京A12345",
    vehicleModel: "大众朗逸 2023款",
    color: "白色",
  },
  inspectionTime: "2024-01-15 14:30",
  inspector: "张师傅",
  vehicleStatus: {
    exterior: {
      frontBumper: "正常",
      rearBumper: "正常",
      leftDoor: "正常",
      rightDoor: "正常",
      windshield: "正常",
      rearWindow: "正常",
    },
    interior: {
      seats: "正常",
      dashboard: "正常",
      airConditioning: "正常",
      audio: "正常",
    },
    functions: {
      engine: "正常",
      brakes: "正常",
      lights: "正常",
      tires: "正常",
    },
  },
  mileage: "12580",
  fuelLevel: "80%",
  notes: "车辆整体状况良好，无明显划痕",
};

const VehicleInspection: React.FC = () => {
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirm = () => {
    setConfirmed(true);
    EventBus.emit("order-check-message", {
      type: "vehicle-inspection-confirm",
      inspectionData: MOCK_INSPECTION_DATA,
      confirmTime: formatDate(new Date()),
    });
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "0 auto" }}>
      <h1 className="text-primary glow-text" style={{ marginBottom: "20px", fontSize: "20px", fontWeight: "bold" }}>验车确认</h1>
      
      <div className="glass-card" style={{ marginBottom: "20px", padding: "16px" }}>
        <h2 className="text-primary" style={{ fontSize: "16px", marginBottom: "12px" }}>车辆信息</h2>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", fontSize: "14px" }}>
          <div className="text-secondary">车牌号：<strong className="text-accent">{MOCK_INSPECTION_DATA.vehicleInfo.plateNumber}</strong></div>
          <div className="text-secondary">车型：{MOCK_INSPECTION_DATA.vehicleInfo.vehicleModel}</div>
          <div className="text-secondary">颜色：{MOCK_INSPECTION_DATA.vehicleInfo.color}</div>
          <div className="text-secondary">里程数：{MOCK_INSPECTION_DATA.mileage} km</div>
        </div>
      </div>

      <div className="glass-card" style={{ marginBottom: "20px", padding: "16px" }}>
        <h2 className="text-primary" style={{ fontSize: "16px", marginBottom: "12px" }}>验车信息</h2>
        <div className="text-secondary" style={{ fontSize: "14px", marginBottom: "8px" }}>
          <div>验车时间：{MOCK_INSPECTION_DATA.inspectionTime}</div>
          <div>验车人员：{MOCK_INSPECTION_DATA.inspector}</div>
          <div>油量：{MOCK_INSPECTION_DATA.fuelLevel}</div>
        </div>
      </div>

      <div className="glass-card" style={{ marginBottom: "20px", padding: "16px" }}>
        <h2 className="text-primary" style={{ fontSize: "16px", marginBottom: "12px" }}>车辆状态</h2>
        <div className="text-secondary" style={{ fontSize: "14px" }}>
          <div style={{ marginBottom: "12px" }}>
            <strong className="text-primary">外观：</strong>
            <div style={{ marginLeft: "16px", marginTop: "4px" }}>
              <div>前保险杠：{MOCK_INSPECTION_DATA.vehicleStatus.exterior.frontBumper}</div>
              <div>后保险杠：{MOCK_INSPECTION_DATA.vehicleStatus.exterior.rearBumper}</div>
              <div>左车门：{MOCK_INSPECTION_DATA.vehicleStatus.exterior.leftDoor}</div>
              <div>右车门：{MOCK_INSPECTION_DATA.vehicleStatus.exterior.rightDoor}</div>
              <div>前挡风玻璃：{MOCK_INSPECTION_DATA.vehicleStatus.exterior.windshield}</div>
              <div>后挡风玻璃：{MOCK_INSPECTION_DATA.vehicleStatus.exterior.rearWindow}</div>
            </div>
          </div>
          <div style={{ marginBottom: "12px" }}>
            <strong className="text-primary">内饰：</strong>
            <div style={{ marginLeft: "16px", marginTop: "4px" }}>
              <div>座椅：{MOCK_INSPECTION_DATA.vehicleStatus.interior.seats}</div>
              <div>仪表盘：{MOCK_INSPECTION_DATA.vehicleStatus.interior.dashboard}</div>
              <div>空调：{MOCK_INSPECTION_DATA.vehicleStatus.interior.airConditioning}</div>
              <div>音响：{MOCK_INSPECTION_DATA.vehicleStatus.interior.audio}</div>
            </div>
          </div>
          <div>
            <strong className="text-primary">功能：</strong>
            <div style={{ marginLeft: "16px", marginTop: "4px" }}>
              <div>发动机：{MOCK_INSPECTION_DATA.vehicleStatus.functions.engine}</div>
              <div>刹车：{MOCK_INSPECTION_DATA.vehicleStatus.functions.brakes}</div>
              <div>灯光：{MOCK_INSPECTION_DATA.vehicleStatus.functions.lights}</div>
              <div>轮胎：{MOCK_INSPECTION_DATA.vehicleStatus.functions.tires}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="glass-card-light" style={{ marginBottom: "20px", padding: "16px" }}>
          <div className="text-secondary" style={{ fontSize: "14px" }}>
          <strong className="text-primary">备注：</strong>
          <div style={{ marginTop: "4px" }}>{truncateText(MOCK_INSPECTION_DATA.notes, 100)}</div>
        </div>
      </div>

      {confirmed ? (
        <div className="glass-card" style={{ padding: "12px", textAlign: "center", borderColor: "var(--color-border-glow)" }}>
          <span className="text-accent">已确认验车信息</span>
        </div>
      ) : (
        <button
          onClick={handleConfirm}
          className="btn-primary"
          style={{
            width: "100%",
          }}
        >
          确认验车信息
        </button>
      )}
    </div>
  );
};

export default VehicleInspection;

